export const NON_BREAKING_SPACE = '\u00a0';
export const NARROW_NON_BREAKING_SPACE = '\u202f';
export const NDASH = '\u2013';
export const EM_DASH = '\u2014';
export const DOT = '\u2022';
export const MIDDLE_DOT = '\u00B7';
export const COLON = '\u003a';
export const EN_DASH = '\u2013';
export const REGULAR_SPACE = '\u0020';
